<template>
  <el-dialog :visible.sync="dialogVisible" width="32%" append-to-body>
    <div class="login-container">
      <div class="login-left">
        <img src="@/assets/img/login/logo-img.png" alt="login-image" class="login-img" />
      </div>
      <div class="login-right">
        <!-- 登录 / 验证码登录 -->
        <template>
          <el-tabs v-model="activeTab">
            <el-tab-pane label="登录" name="登录">
              <el-form :model="formData" ref="formRef" :rules="rules" label-width="0px">
                <el-form-item prop="value">
                  <el-input clearable v-model="formData.value" placeholder="请输入邮箱/手机号/账号" prefix-icon="el-icon-user"
                    @keyup.enter.native="submit" />
                </el-form-item>
                <el-form-item prop="password">
                  <el-input clearable v-model="formData.password" placeholder="请输入密码" type="password" show-password
                    prefix-icon="el-icon-lock" @keyup.enter.native="submit" />
                </el-form-item>
              </el-form>
            </el-tab-pane>

            <el-tab-pane label="验证码登录" name="验证码登录">
              <el-form :model="smsForm" ref="smsFormRef" :rules="smsRules" label-width="0px">
                <el-form-item prop="value">
                  <el-input clearable v-model="smsForm.value" placeholder="请输入邮箱/手机号" prefix-icon="el-icon-phone"
                    @keyup.enter.native="submit" />
                </el-form-item>
                <el-form-item prop="code">
                  <el-row :gutter="10">
                    <el-col :span="14">
                      <el-input clearable v-model="smsForm.code" placeholder="请输入验证码" prefix-icon="el-icon-message"
                        @keyup.enter.native="submit" />
                    </el-col>
                    <el-col :span="10">
                      <el-button @click="sendCode" :disabled="codeTimer > 0">
                        {{ codeTimer > 0 ? `${codeTimer}s后重试` : "获取验证码" }}
                      </el-button>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>

          <el-button type="primary" @click="submit" class="login-button">登录</el-button>


        </template>


      </div>
    </div>
    <collectUserInformation ref="collectUserInformationRef"> </collectUserInformation>
  </el-dialog>
</template>

<script>
import {
  loginRequest,
  getCaptchaCode,
  phoneLogin,
  registerRequest,
  getCheckCode
} from "@/api/login/login";
import collectUserInformation from "./collectUserInformation.vue";
export default {
  components: { collectUserInformation },
  data() {
    return {
      dialogVisible: false,
      activeTab: "登录",
      isRegister: false,
      formData: {
        tenantId: "000001",
        value: "",
        password: ""
      },
      smsForm: {
        value: "",
        code: "",
        tenantId: "000001",
      },
      registerForm: {
        tenantId: "000001",
        phone: "",
        code: ""
      },
      codeTimer: 0,
      codeInterval: null,
      rules: {
        value: [
          { required: true, message: "请输入邮箱/手机号/账号", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, message: "密码至少6位", trigger: "blur" }
        ]
      },
      smsRules: {
        value: [
          { required: true, message: "请输入邮箱/手机号", trigger: "blur" },
          {
            validator: (rule, value, callback) => {

              const isPhone = /^1[3-9]\d{9}$/.test(value);
              const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

              // 判断输入的是数字还是包含 @
              if (/^\d+$/.test(value)) {
                return isPhone
                  ? callback()
                  : callback(new Error("手机号格式不正确"));
              } else if (value.includes("@")) {
                return isEmail
                  ? callback()
                  : callback(new Error("邮箱格式不正确"));
              } else {
                return callback(new Error("请输入正确的手机号或邮箱"));
              }
            },
            trigger: "blur"
          }
        ],
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { len: 6, message: "验证码为6位数字", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    showDialog() {
      this.dialogVisible = true;
    },

    submit() {
      if (this.activeTab === "登录") {
        this.$refs.formRef.validate(valid => {
          if (valid) this.loginWithPassword();
        });
      } else {
        this.$refs.smsFormRef.validate(valid => {
          if (valid) this.loginWithCode();
        });
      }
    },
    loginWithPassword() {
      loginRequest(this.formData).then(res => this.handleLoginResponse(res).catch(err => {
        this.$message.error(err);
      }));
    },
    loginWithCode() {
      phoneLogin(this.smsForm).then(res => {
        this.handleLoginResponse(res);
      }).catch(err => {
        this.$message.error(err);
      })
    },
    registerSubmit() {
      this.$refs.registerFormRef.validate(valid => {
        if (!valid) return;
        registerRequest(this.registerForm).then(res => {
          this.$message.success("注册成功，请登录");
          this.handleLoginResponse(res)
          this.dialogVisible = false;
          this.$refs.collectUserInformationRef.openDialog(res.data.userId);
        })
      });
    },
    handleLoginResponse(res) {
      if (res.code == 200) {
        if (res.data.incomplete === false) {
          // 取消注释以打开用户信息收集弹窗
          this.$refs.collectUserInformationRef.openDialog(res.data.userId);
        }
        const { accessToken, refreshToken, ...userInfo } = res.data;

        this.$store.dispatch("saveLoginInfo", {
          accessToken,
          refreshToken,
          ...userInfo
        });


        this.$message.success("登录成功");
        this.dialogVisible = false;
        this.resetForm();
      }
    },
    sendCode() {
      const form = this.smsForm;
      const value = form.value;

      const isPhone = /^1[3-9]\d{9}$/.test(value);
      const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

      if (!value || (!isPhone && !isEmail)) {
        this.$message.warning("请输入正确的手机号或邮箱");
        return;
      }

      getCaptchaCode({ value: value, tenantId: "000001" }).then(res => {
        if (res.code == 200) {
          this.$message.success("验证码已发送");
          this.startCodeTimer();
        }
      });
    },
    startCodeTimer() {
      this.codeTimer = 60;
      this.codeInterval = setInterval(() => {
        this.codeTimer--;
        if (this.codeTimer <= 0) {
          clearInterval(this.codeInterval);
          this.codeInterval = null;
        }
      }, 1000);
    },
    resetForm() {
      this.$refs.formRef?.resetFields();
      this.$refs.smsFormRef?.resetFields();
    },

  }
};
</script>

<style scoped>
.login-container {
  display: flex;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.login-left {
  flex: 1;
  display: flex;
  border-radius: 12px 0 0 12px;
}

.login-right {
  flex: 1;
  background-color: white;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 0 12px 12px 0;
}

.login-button {
  margin-top: 10px;
  width: 100%;
}

.login-img {
  width: 100%;
  object-fit: cover;
  height: auto;
  border-radius: 12px 0 0 12px;
}

.register-ele {
  margin-top: 10px;
  display: flex;
  justify-content: right;
}

.register-ele .el-button {
  color: #999;
}
</style>

<style scoped lang="scss">
::v-deep .el-dialog {
  border-radius: 12px !important;
}

::v-deep .el-dialog__body {
  padding: unset !important;
}

::v-deep .el-dialog__header {
  padding: unset !important;
  border-bottom: none !important;
}

::v-deep .el-tabs__nav-wrap::after {
  background-color: unset !important;
}

::v-deep .el-tabs__nav-scroll {
  display: flex;
  justify-content: center;
}
</style>
